import { AWS_KINESIS_WEBRTC } from "src/constants";
import { AppDispatch } from "src/domains/Beacon/store";
import { getMeetingTokenThunk } from "src/domains/Beacon/store/meeting/thunks/getMeetingTokenThunk";
import { joinCallThunk } from "src/domains/Beacon/store/meeting/thunks/joinCallThunk";
import { getLocalMediaThunk } from "src/domains/Beacon/store/stream/thunks";
import { handleLoadDefaultDevicesThunk } from "src/domains/Beacon/store/stream/thunks/handleLoadDefaultDevicesThunk";
import { logger } from "src/logging/logger";

interface IParams {
  encodedMeetingToken: string;
  // LD flags necessary for the joinCallThunk
  offerDeviceSelection?: boolean;
  enableORTelligence: boolean;
  externalInputsImageResizing: boolean;
}

export const joinCallWithoutPreCallThunk = ({
  encodedMeetingToken,
  // LD flags necessary for the joinCallThunk
  offerDeviceSelection,
  enableORTelligence,
  externalInputsImageResizing,
}: IParams) => async (dispatch: AppDispatch) => {
  try {
    // Must set the call details first using the meeting token
    logger().info("Getting meeting token...initiated");
    await dispatch(getMeetingTokenThunk({ encodedMeetingToken }));
    logger().info("Getting meeting token...success");

    // Get current user's local media (audio/video)
    logger().info("Getting local media ...initiated");
    await dispatch(getLocalMediaThunk());
    logger().info("Getting local media...success");

    logger().info("handle default devices thunk..initiated");
    await dispatch(handleLoadDefaultDevicesThunk());
    logger().info("handle default devices thunk..success");
    const callDetails: any = JSON.parse(atob(encodedMeetingToken));

    // if (video_vendor && video_vendor === AWS_KINESIS_WEBRTC) {
    //   logger().info(
    //     "A video vendor has been provided. So need to skip twilio : " +
    //       video_vendor
    //   );
    // } else {
    logger().info("Fallback to Avail Cloud, backed by Twilio");
    // Will take care of the join Twilio's room process
    await dispatch(
      joinCallThunk({
        callDetails,
        offerDeviceSelection,
        enableORTelligence,
        externalInputsImageResizing,
      })
    );
    // }
  } catch (error: any) {
    logger().error(
      "There was an error while joining without pre-call screen",
      "User will NOT join the call",
      error.message
    );
  }
};
